import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Play } from "lucide-react";
import { useApp } from "../context/AppContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "do_public_settings";
const TTL = 60 * 1000;

export function usePublicSettings() {
  const [settings, setSettings] = useState(() => {
    try {
      const c = JSON.parse(sessionStorage.getItem(KEY) || "null");
      return c && Date.now() - c.at < TTL ? c.data : null;
    } catch { return null; }
  });
  useEffect(() => {
    if (settings) return;
    axios.get(`${API}/settings/public`).then((r) => {
      sessionStorage.setItem(KEY, JSON.stringify({ at: Date.now(), data: r.data }));
      setSettings(r.data);
    }).catch(() => {});
  }, [settings]);
  return settings;
}

export default function PresentationButton({ onStart }) {
  const { t } = useApp();
  const settings = usePublicSettings();
  const navigate = useNavigate();
  if (!settings?.presentation_mode) return null;
  const start = () => (onStart ? onStart(settings) : navigate("/map?tour=1"));
  return (
    <button className="present-fab" onClick={start} data-testid="presentation-button" aria-label={t("tour.button")}>
      <Play size={16} fill="currentColor" />
      <span>{t("tour.button")}</span>
    </button>
  );
}

export { Link };
